(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/route-result.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/route-result.js');
"use strict";

const {
  useContext
} = React;
const {
  OverviewHero
} = svs.components.marketplaceCompetition.overviewHero;
const {
  CompetitionMenuContext
} = svs.components.marketplaceCompetition.competitionMenu;
const {
  Highscore
} = svs.components.marketplaceCompetition.routeResult.highscore;
const RouteResult = () => {
  const {
    competitionMenu
  } = useContext(CompetitionMenuContext);
  return React.createElement(React.Fragment, null, React.createElement(OverviewHero, null), React.createElement("span", {
    className: "competition-overflow-up"
  }, competitionMenu), React.createElement(Highscore, null));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.RouteResult', RouteResult);

 })(window);